import {getPrivateAxios} from '@blesk-frontend/api';

export const fetchBillingUnsubscribe = async () => {
  const {data} = await getPrivateAxios().post<void>('/billing/unsubscribe');
  return data;
};
